import { Link } from "react-router-dom";
import { blacklistEntries } from "@/mocks/blacklist";
import type { RiskEntry } from "@/types/content";
import RiskRecordCard from "@/components/feature/RiskRecordCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FeaturedRisk() {
  const highRisk = (blacklistEntries as RiskEntry[]).filter((entry) => entry.riskLevel === "high").slice(0, 3);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="高危急报"
            title="这些平台，近期反馈最集中"
            desc="以下记录已有多名用户提交同类反馈，风险等级为高危。查看详情前，请先确认自己是否已发生交易。"
          />
          <Link
            to="/blacklist?level=high"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-accent-300 bg-accent-50 px-4 py-2.5 font-label text-sm font-medium text-accent-700 transition-colors hover:bg-accent-100 cursor-pointer"
          >
            <i className="ri-error-warning-line" />
            只看高危记录
          </Link>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {highRisk.map((entry) => (
            <RiskRecordCard key={entry.id} entry={entry} />
          ))}
        </div>
      </div>
    </section>
  );
}